'use client';

import React, { useEffect, useState } from 'react';

const NoSSR = (props: {children: React.ReactNode;}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (isClient ? props.children : null) as JSX.Element;
};

export default NoSSR;
